import React from "react";
import "./styles.css";

const FormMinorDataComponent = ({
  questionResponse,
  responsibleMinorData,
  onChangeResponsibleMinorData,
  setShowErrorModal,
}) => {
  const onChange = (event) => {
    const { value, name } = event.target;
    const updatedResponsibleMinorData = {
      ...responsibleMinorData,
      [name]: value,
    };

    onChangeResponsibleMinorData(updatedResponsibleMinorData);
  };

  const onClickNext = () => {
    if (
      responsibleMinorData.name !== "" &&
      responsibleMinorData.address !== "" &&
      responsibleMinorData.city !== "" &&
      responsibleMinorData.dni !== "" &&
      responsibleMinorData.postalCode !== "" &&
      responsibleMinorData.province !== ""
    ) {
      questionResponse(1);
    } else {
      setShowErrorModal(true);
    }
  };

  const onClickBack = () => {
    questionResponse(1);
  };

  return (
    <div className="contentMinorData">
      <h1 className="titleMinorData">Datos del representante</h1>
      <div className="minorDataComponent">
        <div className="column">
          <p>Nombre y apellidos</p>
          <input
            type="text"
            className="inputFormComponent"
            name="name"
            value={responsibleMinorData.name}
            onChange={(event) => onChange(event)}
          />
          <p>Domicilio</p>
          <input
            type="text"
            className="inputFormComponent"
            name="address"
            value={responsibleMinorData.address}
            onChange={(event) => onChange(event)}
          />
          <p>Código postal</p>
          <input
            type="text"
            className="inputFormComponent"
            name="postalCode"
            value={responsibleMinorData.postalCode}
            onChange={(event) => onChange(event)}
          />
        </div>
        <div className="column">
          <p>Población</p>
          <input
            type="text"
            className="inputFormComponent"
            name="city"
            value={responsibleMinorData.city}
            onChange={(event) => onChange(event)}
          />
          <p>Provincia</p>
          <input
            type="text"
            className="inputFormComponent"
            name="province"
            value={responsibleMinorData.province}
            onChange={(event) => onChange(event)}
          />
          <p>DNI/NIF</p>
          <input
            type="text"
            className="inputFormComponent"
            name="dni"
            value={responsibleMinorData.dni}
            onChange={(event) => onChange(event)}
          />
        </div>
      </div>
      <div className="btnMinoData">
        <button className="btnForm" onClick={onClickBack}>
          Atrás
        </button>
        <button className="btnForm" onClick={onClickNext}>
          Aceptar
        </button>
      </div>
    </div>
  );
};

export default FormMinorDataComponent;
